//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import payforList from "../../component/payforList/index";
import goodInfo from "../../component/goodInfo/index";
import httpApi from "../../api/cashier";

import { Toast } from "mint-ui";
import wx from "weixin-js-sdk";
export default {
  name: "order",
  data() {
    return {
      appid: null,
      key: null,
      selectStatus: "阳澄湖大闸蟹",
      errorMsg: "",
      prices: "",
      goodsDetail: {},
      channel_code: "",
      trade_type: ""
    };
  },
  components: {
    // New,
    payforList,
    goodInfo
  },
  created() {},
  mounted() {
    this.goodsDetail = JSON.parse(localStorage.getItem("data"));
    console.log(this.goodsDetail);
    this.submit();
  },
  methods: {
    submit() {
      let _this = this;
      let config = {
        myapp_id: this.goodsDetail.myapp_id,
        device_id: this.goodsDetail.device_sn
      };

      httpApi.payGetMessage(config).then(res => {
        if (res.status == 200) {
          _this.channel_code = res.data.channel_code;
          _this.trade_type = res.data.trade_type;
        } else {
          Toast({
            message: res.msg,
            iconClass: "icon icon-success",
            duration: 2000
          });
        }
      });
    },
    putorder() {
      let goodsDetail = this.goodsDetail;
      let _this = this;
      let subData = {
        myapp_id: goodsDetail.myapp_id,
        total_amount:parseInt(parseFloat(this.prices *100).toFixed(0)),
        subject: decodeURI(goodsDetail.subject),
        trade_type: this.trade_type,
        device_id: goodsDetail.device_sn,
        payment_type: this.channel_code
      };
      if (this.trade_type == "jsapi") {
        subData.sub_openid = localStorage.getItem("openid");
      }
      httpApi
        .payunifiedOrder(subData)
        .then(res => {
          if (res.status == 200) {
            if (this.channel_code == "alipay") {
              let div1 = document.createElement("div"); // 创建div
              div1.innerHTML = res.data.form;
              document.body.appendChild(div1);
              document.forms[0].submit();
            } else {
              let config = res.data;
              wx.config({
                debug: false,
                appId: config.appid,
                timestamp: config.time_stamp,
                nonceStr: config.nonce_str,
                signature: config.pay_sign,
                jsApiList: ["chooseWXPay"],
                success(res) {
                  console.log("config设置成功:", res);
                },
                fail(err) {
                  console.log("config设置fail:", err);
                }
              });
              wx.ready(function() {
                wx.chooseWXPay({
                  timestamp: config.time_stamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                  nonceStr: config.nonce_str, // 支付签名随机串，不长于 32 位
                  package: `prepay_id=${config.prepay_id}`, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                  signType: config.sign_type, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                  paySign: config.pay_sign, // 支付签名
                  success: function(res) {
                    // 支付成功后的回调函数
                    console.log("支付拉起success:", res);
                    // cb(res);
                    Toast({
                      message: "支付成功",
                      iconClass: "icon icon-success",
                      duration: 2000
                    });
                    setTimeout(function() {
                      location.replace(config.redirect_url);
                    }, 1000);
                  },
                  fail: function(err) {
                    console.log("支付拉起fail:", err);
                    //失败回调函数
                    Toast({
                      message: "支付失败" + err.errMsg,
                      iconClass: "icon icon-success",
                      duration: 2000
                    });
                    setTimeout(function() {
                      location.replace(config.redirect_url);
                    }, 1000);
                    // errorCb(res);
                  }
                });
              });
            }
          } else {
          }
          this.subflag = true;
          _this.isloading = false;
        })
        .catch(err => {
          _this.isloading = false;
          // Toast({
          //   message: err.msg,
          //   iconClass: "icon icon-success",
          //   duration: 2000
          // });
          this.subflag = true;
        });
      // subData[""]
      // setTimeout(() => {
      //   _this.subflag = true
      // }, 2000);
      console.log("点击提交");
    },
    getStrSign() {
      let strs = [];
      let stra = "";
      for (let i = 65; i <= 90; i++) {
        strs.push(i);
      }
      for (let i = 97; i <= 122; i++) {
        strs.push(i);
      }
      for (let i = 0; i < 32; i++) {
        // let ele = array[i];
        let num = Math.floor(Math.random() * strs.length);
        stra += String.fromCharCode(strs[num]);
      }
      return stra;
    }
  }
};
// .mint-switch-input:checked + .mint-switch-core



// WEBPACK FOOTER //
// ./src/components/pay/index.vue